import { Button, ButtonColorVariant, ButtonSize, ButtonVariant } from "@/components/ui/button";
import { RowData } from "@tanstack/react-table";
import { t } from "i18next";
import { ChevronRight } from "lucide-react";
import { RowWithIdentifier } from "../_helpers/row-identifier";
import { ImplementedDisplayColumnDef } from "../types";

export function createExpansionColumn<
  TData extends RowData & RowWithIdentifier,
  TValue = unknown,
>(): ImplementedDisplayColumnDef<TData, TValue> {
  return {
    id: "expand",
    size: 50,
    minSize: 50,
    maxSize: 50,
    enableSorting: false,
    align: "center",
    header: () => null,
    cell: ({ row }) => (
      <div className="flex items-center justify-center">
        {row.getCanExpand() && (
          <Button
            variant={ButtonVariant.Ghost}
            colorVariant={ButtonColorVariant.Secondary}
            size={ButtonSize.Sm}
            className="h-8 w-8 p-0"
            onClick={(e) => {
              row.toggleExpanded();
              e.stopPropagation();
              e.preventDefault();
            }}
            aria-label={row.getIsExpanded() ? t("common:Collapse") : t("common:Expand")}
          >
            <ChevronRight
              className={`h-4 w-4 transition-transform ${row.getIsExpanded() ? "rotate-90 transform" : ""}`}
            />
          </Button>
        )}
      </div>
    ),
  };
}
